<script>
import compoment from '@/components/draggable/CustomComponents/Input/DInputEditor'
export default {
  name: 'DIdentityEditor',
  extends: compoment
}
</script>
